//import { Grid, makeStyles, Typography, Paper, TextField } from '@material-ui/core';
import { Grid, makeStyles, Typography, Paper, TextField, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
//import React, { useState } from 'react';
import React, { useState, useEffect } from 'react';
import { WithTrafiLayout } from './TrafiLayout';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { TextButton } from './solteq-react/forms/Buttons';
import authService from '../authService';
import AlertNotification from './AlertNotification';
import { Visibility, VisibilityOff } from '@material-ui/icons';
//import { useHistory } from 'react-router-dom';
//import { redirect } from 'react-router';

//import { ErrorBoundary } from 'react-error-boundary';

//import crypto from 'crypto';

//import { scrypt, randomBytes, timingSafeEqual } from "crypto";
//import { promisify } from "util";

// scrypt is callback based so with promisify we can await it
//const scryptAsync = promisify(scrypt);

//import getUser from '../GetUser';

//import axios from 'axios';

//import bodyParser from "body-parser";
//import { showNotification } from './Notifications.js';

const useFormStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            marginTop: '30px'
        }
    }
}));

const AddPassword = () => {
    const formClasses = useFormStyles();
    const isBigTitleUsed = useMediaQuery('(min-width:500px)');
    const isExtraPaddingUsed = useMediaQuery('(min-width:1320px)');
    const isLeftRightAlignUsed = useMediaQuery('(min-width:1005px)');
    const isDescriptionShown = useMediaQuery('(min-height:730px)');
    const [alertMessage, setAlertMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State for confirm password visibility

    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);

//    const navigate = useHistory();

    //    const bodyParser = require('body - parser');
    //    const express = require('express');

    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleToggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const url = new URL(window.location.href);
    const ParamUserName = url.searchParams.get('nimi');
    const ParamSecurityStamp = url.searchParams.get('security');
    //    const userId = url.searchParams.get('id');

    // Define password validation criteria
    const passwordCriteria = {
        minLength: 10,
        hasUppercase: /[A-Z]/,
        hasLowercase: /[a-z]/,
        hasNumber: /[0-9]/,
        hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/
    };

    const handleSubmit = async (e) => {
        //        alert('ParamUserName: ' + ParamUserName + ', ParamSecurityStamp: ' + ParamSecurityStamp);
        //        alert('userId2: ' + userId);

        //        alert('SecurityStamp: ' + getSecurityStamp);

        e.preventDefault();
        //        showNotification('Connected!', theme);

        //        const hash = crypto.createHash('sha256');
        //        alert('password: ' + password);
        //        hash.update(password);
        //        const hashedPassword = hash.digest('hex'); // Convert to hexadecimal format

        //        alert('hashedPassword: ' + hashedPassword);
        //        conslole.log('hashedPassword1: ' + hashedPassword);
        //        console.write('hashedPassword2: ' + hashedPassword);

        // Call the authService with the hashed password
        //        const result = await authService.AddPassword(ParamUserName, hashedPassword, ParamSecurityStamp);
        //          const result = await authService.AddPassword(ParamUserName, password, ParamSecurityStamp);

        // Validate username
        if (!ParamUserName || ParamUserName.trim() === '') {
            setErrorMessage('Käyttäjätunnus ei voi olla tyhjä.');
            return;
        }

        // Validate password
        if (password.length < passwordCriteria.minLength) {
            setErrorMessage('Salasanan täytyy olla vähintään 10 merkin pituinen.');
            return;
        }
        if (!passwordCriteria.hasUppercase.test(password)) {
            setErrorMessage('Salasanan pitää sisältää vähintään yksi iso kirjain.');
            return;
        }
        if (!passwordCriteria.hasLowercase.test(password)) {
            setErrorMessage('Salasanan pitää sisältää vähintään yksi pieni kirjain.');
            return;
        }
        if (!passwordCriteria.hasNumber.test(password)) {
            setErrorMessage('Salasanan pitää sisältää vähintään yksi numero.');
            return;
        }
        if (!passwordCriteria.hasSpecialChar.test(password)) {
            setErrorMessage('Salasanan pitää sisältää vähintään yksi erikoismerkki.');
            return;
        }

        // Check if passwords match
        if (password !== confirmPassword) {
            setErrorMessage('Annetut salasanat eivät täsmää!');
            return;
        }

        //        const result = await authService.AddPassword(ParamUserName, password, ParamSecurityStamp);
        //        result.error && setErrorMessage(result.error.message ? result.error.message : 'Tapahtui virhe!');
        //        setMessage(result.error.message);
        //        alert(`Error: ${error.message}`);

        //        setMessage('Tapahtui virhe!');
        //        return;

        try {
            const result = await authService.AddPassword(ParamUserName, password, ParamSecurityStamp);
            //            setMessage(result);

            //            if (result?.success || result?.status === 'ok' || result === 'OK') {
            if (result === 'OK') {
                setErrorMessage('');
                //                setPassword('');
                //                setConfirmPassword('');
                setOpenPopup(true); // Show popup
            } else {
                setErrorMessage(result);
            }
        } catch (err) {
            setErrorMessage(err.message || 'Virhetilanne');
        }

        // Show the result in an alert
        //            setErrorMessage('Result: ${JSON.stringify(result)}');
        //            alert(`Result: ${JSON.stringify(result)}`);

        //setMessage(`${JSON.stringify(result)}`);
        //            setMessage(`Virhe: ${error.message}`);
        //} catch (error) {
        // Handle errors and show them in an alert
        //            alert(`Error: ${error.message}`);
        //            setMessage(`Virhe: ${error.message}`);
        //setMessage(`${JSON.stringify(result)}`);

        //            setErrorMessage('Error: ${error.message}');
        //}

        // If all validations pass
        //        setMessage('Form submitted successfully!');
        // Add your form submission logic here

        // Reset form fields
        //        setPassword('');
        //        setConfirmPassword('');
        //        setMessage('');

        // Simulate form submission
        //        try {
        //            setIsLoading(true);
        //            const response = await authService.updatePassword(username, password); // Example API call
        //            if (response.status === 'success') {
        //                setMessage('Form submitted successfully!');
        //                setPassword('');
        //                setConfirmPassword('');
        //            } else {
        //                throw new Error(response.message || 'An error occurred during submission.');
        //            }
        //        } catch (error) {
        //            setAlertMessage(error.message); // Display error message in AlertNotification
        //        } finally {
        //            setIsLoading(false);
        //        }
    };

    const handleClosePopup = () => {
        setOpenPopup(false);
        //        history.push('/your-target-page'); // Replace with your actual route
        return window.location.replace("/Preview");
    };

    function User({ name }) {
        useEffect(() => {
            document.title = name;
        }, [name]);

        return <h1>{name}</h1>;
    }

    return (
        <>
            <footer style={{ position: 'absolute', bottom: '5px', width: '100%', textAlign: 'center' }}>
                <Typography style={{ color: 'white' }} variant="caption">
                    <br />
                    <b>Tietojen tekninen toimitus</b> Solteq Oyj, Karhumäenkuja 2, 01530 Vantaa
                </Typography>
            </footer>
            <div style={{ width: '100%' }}>
                <Grid container justifyContent="center">
                    <Grid item container direction="column" style={{ minWidth: 0, width: 'auto' }}>
                        <Grid item style={{ marginTop: '6%' }}>
                            <AlertNotification alertMessage={alertMessage} handleClose={() => setAlertMessage(undefined)} />
                        </Grid>
                        <Grid item style={{ marginTop: '4%' }} container direction={isLeftRightAlignUsed ? 'row' : 'column'} alignItems="center" justifyContent="center">
                            <Grid item container direction="column" style={{ maxWidth: '513px' }}>
                                <Grid item>
                                    <Paper
                                        style={{
                                            paddingTop: '10px',
                                            paddingLeft: '40px',
                                            paddingRight: '40px',
                                            paddingBottom: '40px',
                                            margin: '20px',
                                            backgroundColor: '#fafafa'
                                        }}
                                        elevation={0}
                                    >
                                        <form onSubmit={handleSubmit} className={formClasses.root} noValidate autoComplete="off">
                                            <TextField disabled label="Käyttäjätunnus" variant="outlined" fullWidth value={username || ParamUserName} />
                                            <div>
                                                <Typography style={{ color: 'blue', fontWeight: '500', fontSize: '16px' }}>
                                                    <b>Salasanan kriteerit:</b>
                                                </Typography>
                                                <Typography style={{ color: 'black', fontWeight: '300', paddingLeft: '10px', fontSize: '14px' }}>
                                                    - vähintään 10 merkkiä pitkä
                                                </Typography>
                                                <Typography style={{ color: 'black', fontWeight: '300', paddingLeft: '10px', fontSize: '14px' }}>
                                                    - sisältää vähintään yhden ison kirjaimen
                                                </Typography>
                                                <Typography style={{ color: 'black', fontWeight: '300', paddingLeft: '10px', fontSize: '14px' }}>
                                                    - sisältää vähintään yhden pienen kirjaimen
                                                </Typography>
                                                <Typography style={{ color: 'black', fontWeight: '300', paddingLeft: '10px', fontSize: '14px' }}>
                                                    - sisältää vähintään yhden numeron
                                                </Typography>
                                                <Typography style={{ color: 'black', fontWeight: '300', paddingLeft: '10px', fontSize: '14px' }}>
                                                    - sisältää vähintään yhden erikoismerkin (esim. !@#$%^&*(),.?":{}|)
                                                </Typography>
                                                <br />
                                                {errorMessage && (
                                                    <Typography color="error" style={{ fontSize: '14px' }}>
                                                        <b>{errorMessage}</b>
                                                    </Typography>
                                                )}
                                                {message && (
                                                    <Typography style={{ fontSize: '16px', color: 'blue' }}>
                                                        <b>{message}</b>
                                                    </Typography>
                                                )}
                                                <Dialog open={openPopup} onClose={handleClosePopup}>
                                                    <DialogTitle></DialogTitle>
                                                    <DialogContent>
                                                        <Typography>Salasana tallennettu. Voit jatkaa sovelluksen käyttöä.</Typography>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button onClick={handleClosePopup} color="primary">
                                                            OK
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </div>
                                            <TextField
                                                disabled={isLoading}
                                                label="Syötä salasana"
                                                variant="outlined"
                                                autoComplete="new-password" // Prevents autofill
                                                type={showPassword ? 'text' : 'password'} // Toggle between 'text' and 'password'
                                                fullWidth
                                                onChange={(e) => setPassword(e.target.value)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton onClick={handleTogglePasswordVisibility}>
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    )
                                                }}
                                            />
                                            <TextField
                                                disabled={isLoading}
                                                label="Syötä salasana uudestaan"
                                                variant="outlined"
                                                autoComplete="new-password" // Prevents autofill
                                                type={showConfirmPassword ? 'text' : 'password'} // Toggle between 'text' and 'password'
                                                fullWidth
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton onClick={handleToggleConfirmPasswordVisibility}>
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    )
                                                }}
                                            />
                                            <TextButton disabled={isLoading} variant="contained" color="secondary" fullWidth style={{ height: '64px' }} type="submit">
                                                {isLoading ? 'Päivitetään...' : 'Päivitä salasana'}
                                            </TextButton>
                                        </form>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent="flex-end" style={{ opacity: isDescriptionShown ? 100 : 0 }}>
                            <Grid item></Grid>
                            <Grid item style={{ maxWidth: '513px', paddingLeft: '20px', paddingRight: '20px' }}>
                                <Typography style={{ color: 'white', fontWeight: '500' }}>
                                    Solteqin ajoneuvokysely on väylä ajantasaisiin tietoihin kaikille autoalan toimijoille. Jotta voit käyttää ajoneuvokyselyä sinun tulee
                                    sopia palvelusopimus Solteq Oyj:n kanssa.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

const WrappedAddPassword = WithTrafiLayout(AddPassword, false);
export default WrappedAddPassword;
